import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, CheckCircle2 } from 'lucide-react';
const speakers = [{
  name: 'Dr. María Castellanos',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=200&h=200&fit=crop',
  cv: 'H-index 42 • 120+ publications • EADV Board Member'
}, {
  name: 'Prof. Klaus Hoffmann',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=200&h=200&fit=crop',
  cv: 'H-index 38 • 95+ publications • AAD Fellow'
}, {
  name: 'Dr. Yuki Tanaka',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=200&h=200&fit=crop',
  cv: 'H-index 35 • 80+ publications • JDA Council'
}];
const topics = [{
  id: 'efficacy',
  label: 'Efficacy Data',
  color: 'bg-blue-500'
}, {
  id: 'safety',
  label: 'Safety Profile',
  color: 'bg-green-500'
}, {
  id: 'longterm',
  label: 'Long-term Data',
  color: 'bg-purple-500'
}, {
  id: 'qol',
  label: 'Quality of Life',
  color: 'bg-amber-500'
}, {
  id: 'realworld',
  label: 'Real-world Evidence',
  color: 'bg-cyan-500'
}, {
  id: 'selection',
  label: 'Patient Selection',
  color: 'bg-rose-500'
}];
export function LayerMenu() {
  const [selectedSpeaker, setSelectedSpeaker] = useState(0);
  const [selectedTopic, setSelectedTopic] = useState('efficacy');
  return <section className="py-24 bg-slate-950" data-id="element-104">
      <div className="max-w-7xl mx-auto px-6" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-106">
          <div className="flex items-center gap-3 mb-4" data-id="element-107">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-108">
              LAYER 2
            </div>
            <Menu className="w-5 h-5 text-red-600" data-id="element-109" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-110">
            The Menu
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl" data-id="element-111">
            Choose your path — browse by speaker expertise or by clinical topic.
            A premium streaming experience that puts the viewer in control.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-112">
          {/* Speaker Selection */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-113">
            <h3 className="text-2xl font-semibold text-white mb-6 flex items-center gap-2" data-id="element-114">
              <span className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center text-sm" data-id="element-115">
                1
              </span>
              Select Speaker
            </h3>
            <div className="space-y-4" data-id="element-116">
              {speakers.map((speaker, index) => <motion.button key={speaker.name} onClick={() => setSelectedSpeaker(index)} whileHover={{
              scale: 1.02
            }} className={`w-full flex items-center gap-4 p-4 rounded-xl transition-all ${selectedSpeaker === index ? 'bg-red-600 border-2 border-red-500' : 'bg-slate-900 border-2 border-slate-800 hover:border-slate-700'}`} data-id="element-117">
                  <img src={speaker.image} alt={speaker.name} className="w-16 h-16 rounded-full object-cover" data-id="element-118" />
                  <div className="flex-1 text-left" data-id="element-119">
                    <div className="font-semibold text-white mb-1" data-id="element-120">
                      {speaker.name}
                    </div>
                    <div className="text-sm text-slate-300" data-id="element-121">{speaker.cv}</div>
                  </div>
                  {selectedSpeaker === index && <CheckCircle2 className="w-6 h-6 text-white flex-shrink-0" data-id="element-122" />}
                </motion.button>)}
            </div>
          </motion.div>

          {/* Topic Selection */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-123">
            <h3 className="text-2xl font-semibold text-white mb-6 flex items-center gap-2" data-id="element-124">
              <span className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center text-sm" data-id="element-125">
                2
              </span>
              Select Topic
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-126">
              {topics.map(topic => <motion.button key={topic.id} onClick={() => setSelectedTopic(topic.id)} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.98
            }} className={`p-6 rounded-xl transition-all ${selectedTopic === topic.id ? 'bg-slate-800 border-2 border-white shadow-lg shadow-white/10' : 'bg-slate-900 border-2 border-slate-800 hover:border-slate-700'}`} data-id="element-127">
                  <div className={`w-3 h-3 rounded-full ${topic.color} mb-3`} data-id="element-128" />
                  <div className="font-semibold text-white text-left" data-id="element-129">
                    {topic.label}
                  </div>
                </motion.button>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mt-8 p-6 bg-slate-900 border border-slate-800 rounded-xl" data-id="element-130">
              <div className="text-sm text-slate-400 mb-2" data-id="element-131">Now Playing:</div>
              <div className="text-lg font-semibold text-white" data-id="element-132">
                {speakers[selectedSpeaker].name} •{' '}
                {topics.find(t => t.id === selectedTopic)?.label}
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}